<template>
    <div class="filters">
        <app-sub-title text="Filtros" />
        <b-row class="justify-content-left">
            <b-col cols="12" md="5" v-if="!isClientUser">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    :value="client"
                    @change="client => $emit('client-change', client)"
                    :disabled="
                        [
                            'vigilante',
                            'cliente-admin',
                            'miembro-asociado',
                            'supervisor',
                        ].includes(user.profile.slug)
                    "
                />
            </b-col>
            <b-col cols="12" md="2">
                <app-form-text-input
                    placeholder="Placa"
                    :input-classes="{ 'plate-input': true }"
                    v-model="filters.plate"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="2">
                <app-date-picker
                    v-model="filters.from"
                    placeholder="Desde"
                ></app-date-picker>
            </b-col>
            <b-col cols="12" md="2">
                <app-date-picker
                    v-model="filters.to"
                    placeholder="Hasta"
                ></app-date-picker>
            </b-col>
            <div class="w-100"></div>
            <b-col cols="12" md="4">
                <app-autocomplete
                    :get-object="false"
                    placeholder="Autor"
                    v-model="filters.userId"
                    :items="guards"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="4">
                <app-form-text-input
                    placeholder="palabras clave"
                    v-model="filters.keyWords"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="4" class="right-spaced">
                <b-button
                    variant="primary"
                    @click="$emit('filter', filters)"
                    class="mr-2"
                >
                    <i class="fa fa-filter"></i>
                </b-button>
                <b-button variant="secondary" @click="clearFilters">
                    <i class="fa fa-times-circle"></i>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            filters: {
                plate: '',
                from: '',
                to: '',
                keyWords: '',
                userId: '',
                clientId: '',
            },
            guards: [],
        }
    },
    computed: {
        ...mapGetters(['clients', 'client']),
        isClientUser() {
            return this.user.profile.slug === 'cliente-admin' || 
                   this.user.profile.client_side === true;
        },
    },
    methods: {
        clearFilters() {
            this.filters.plate = ''
            this.filters.from = ''
            this.filters.to = ''
            this.filters.keyWords = ''
            this.$emit('clearFilters')
        },
        async loadGuards() {
            const { data } = await repo.get('users/guards')
            this.guards = data
        },
    },
    mounted() {
        this.loadGuards()
        this.load('clients')
        
        // Si es cliente-admin o client_side, establecer el cliente automáticamente
        if (this.isClientUser && this.client) {
            this.$emit('client-change', this.client)
        }
    },
}
</script>
